import { render, staticRenderFns } from "./GroupEditorModal.vue?vue&type=template&id=06b1f805&scoped=true&"
import script from "./GroupEditorModal.vue?vue&type=script&lang=js&"
export * from "./GroupEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupEditorModal.vue?vue&type=style&index=0&id=06b1f805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1f805",
  null
  
)

export default component.exports